import { useRef, useState } from "react";

export default function BeforeAfter({ before, after, title, category }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const update = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100)));
  };

  return (
    <div data-testid="before-after-slider" className="group">
      <div
        ref={ref}
        className="relative aspect-[16/10] overflow-hidden rounded-2xl shadow-lg shadow-forest/10 cursor-ew-resize select-none"
        style={{ touchAction: "none" }}
        onPointerDown={(e) => {
          dragging.current = true;
          e.currentTarget.setPointerCapture(e.pointerId);
          update(e.clientX);
        }}
        onPointerMove={(e) => dragging.current && update(e.clientX)}
        onPointerUp={() => (dragging.current = false)}
        onPointerCancel={() => (dragging.current = false)}
      >
        <img src={after} alt={`${title} — après`} draggable={false} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
          <img src={before} alt={`${title} — avant`} draggable={false} className="w-full h-full object-cover" />
        </div>

        <span className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-coal/70 backdrop-blur text-sand text-[11px] uppercase tracking-[0.2em] font-semibold pointer-events-none">
          Avant
        </span>
        <span className="absolute top-4 right-4 px-3 py-1.5 rounded-full bg-moss/90 text-white text-[11px] uppercase tracking-[0.2em] font-semibold pointer-events-none">
          Après
        </span>

        <div className="absolute inset-y-0 pointer-events-none" style={{ left: `${pos}%` }}>
          <div className="absolute inset-y-0 -translate-x-1/2 w-[2px] bg-white/90" />
          <div className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow-xl flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1E3A2B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M8 7l-5 5 5 5M16 7l5 5-5 5" />
            </svg>
          </div>
        </div>
      </div>
      <div className="mt-4 flex items-start justify-between gap-4">
        <div>
          <span className="text-[11px] uppercase tracking-[0.22em] font-semibold text-moss">{category}</span>
          <h3 className="mt-1 font-serif text-xl text-forest">{title}</h3>
        </div>
        <span className="hidden sm:inline text-[11px] text-coal/50 whitespace-nowrap pt-1">Glissez le curseur</span>
      </div>
    </div>
  );
}
